import type { RouteLocationNormalized } from 'vue-router';
import { AnalyticsBrowser } from '@segment/analytics-next';
import config from '@/config/widgets';
import type AnalyticsModule from './analyticsModule';
import type { SetUserPropertiesParams } from './analyticsModule';

export default class implements AnalyticsModule {
  analytics: AnalyticsBrowser;

  orgId: string | undefined;

  constructor() {
    this.analytics = AnalyticsBrowser.load(
      { writeKey: config.segmentWriteKey, cdnURL: 'https://events-cdn.riskledger.com' },
      {
        integrations: {
          'Segment.io': {
            apiHost: 'events-api.riskledger.com/v1',
          },
        },
      },
    );
  }

  trackView(to: RouteLocationNormalized, from: RouteLocationNormalized) {
    this.analytics.page(
      to.name ? to.name.toString() : to.path,
      {
        previousPath: from.path,
      },
      { context: { groupId: this.orgId } },
    );
  }

  trackEvent(eventName: string, metaObject: Record<string, any>) {
    this.analytics.track(eventName, metaObject, { context: { groupId: this.orgId } });
  }

  setUserProperties({ user, org }: SetUserPropertiesParams) {
    if (user) {
      this.analytics.identify(user.userID, {
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        createdAt: user.createdAt,
        activatedAt: user.activatedAt,
        status: user.status,
        role: user.role,
        team: user.team,
        organisation_id: user.organisationID,
        groupId: user.organisationID,
      });
    }
    if (org) {
      this.orgId = org.orgID;
      this.analytics.group(org.orgID, {
        name: org.name,
        website: org.website,
        isSupplier: org.isSupplier,
        isClient: org.isClient,
        paid: org.paid,
        organisation_id: org.orgID,
        groupId: org.orgID,
      });
    }
  }

  reset() {
    // NOOP
  }

  logError() {
    // NOOP
  }
}
